import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: [Date]</p>

      <section>
        <h2>1. Information We Collect</h2>
        <p>
          We collect information you provide directly to us, including your name,
          email address, phone number, and booking details when you use Enturf.
        </p>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>
          We use the information we collect to provide, maintain, and improve our
          services, process bookings, and communicate with you about your account.
        </p>
      </section>

      <section>
        <h2>3. Location Data</h2>
        <p>
          With your permission, we collect location data to show nearby sports
          facilities and provide location-based recommendations.
        </p>
      </section>

      <section>
        <h2>4. Data Security</h2>
        <p>
          We implement appropriate security measures to protect your personal
          information against unauthorized access or disclosure.
        </p>
      </section>

      <section>
        <h2>5. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at
          support@enturf.com
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;